export interface LastLocationUpdateStatus {
  lastUpdate: string;
  isRecent: boolean;
}

const LOCATION_DATE_TIME_PATTERN =
  /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;

const parseLocationDateTime = (dateTime: string) => {
  const normalizedDateTime = dateTime
    .replace(/Z$/, '')
    .replace('T', ' ')
    .split('.')[0];

  const match = LOCATION_DATE_TIME_PATTERN.exec(normalizedDateTime);

  if (!match) return null;

  const [, year, month, day, hour, minute, second] = match.map(Number);
  const parsedDate = new Date(year, month - 1, day, hour, minute, second);

  if (
    parsedDate.getFullYear() !== year ||
    parsedDate.getMonth() !== month - 1 ||
    parsedDate.getDate() !== day ||
    parsedDate.getHours() !== hour ||
    parsedDate.getMinutes() !== minute ||
    parsedDate.getSeconds() !== second
  ) {
    return null;
  }

  return parsedDate;
};

export const getLastLocationUpdateStatus = (
  dateTime: unknown,
  now: Date = new Date(),
): LastLocationUpdateStatus => {
  if (typeof dateTime !== 'string' || !dateTime) {
    return {
      lastUpdate: 'Indisponível',
      isRecent: false,
    };
  }

  const updateTime = parseLocationDateTime(dateTime);

  if (!updateTime) {
    return {
      lastUpdate: 'Indisponível',
      isRecent: false,
    };
  }

  const diffMins = Math.trunc((now.getTime() - updateTime.getTime()) / 60000);

  if (diffMins < 1) {
    return {
      lastUpdate: 'Agora mesmo',
      isRecent: true,
    };
  }

  if (diffMins === 1) {
    return {
      lastUpdate: '1 minuto atrás',
      isRecent: true,
    };
  }

  if (diffMins < 60) {
    return {
      lastUpdate: `${diffMins} minutos atrás`,
      isRecent: diffMins < 5,
    };
  }

  const diffHours = Math.trunc(diffMins / 60);

  if (diffHours < 24) {
    return {
      lastUpdate: `${diffHours} ${diffHours === 1 ? 'hora' : 'horas'} atrás`,
      isRecent: false,
    };
  }

  const diffDays = Math.trunc(diffHours / 24);

  return {
    lastUpdate: `${diffDays} ${diffDays === 1 ? 'dia' : 'dias'} atrás`,
    isRecent: false,
  };
};
